class QuoteCartForm extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.quote-cart-form__toggle');
    this.form = this.querySelector('.quote-cart-form__fields');
    this.status = this.querySelector('.quote-cart-form__status');
    this.workerUrl = this.dataset.workerUrl;
    this.turnstileWidgetId = null;

    this.toggle.setAttribute('aria-expanded', String(!this.form.hidden));
    this.toggle.addEventListener('click', () => {
      const willOpen = this.form.hidden;
      this.form.hidden = !this.form.hidden;
      this.toggle.setAttribute('aria-expanded', String(!this.form.hidden));
      if (willOpen) this.renderTurnstile();
    });

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitQuote();
    });
  }

  renderTurnstile(attempt = 0) {
    const widget = this.querySelector('.cf-turnstile');
    if (!widget || widget.dataset.turnstileRendered === 'true') return;
    if (window.turnstile && typeof window.turnstile.render === 'function') {
      this.turnstileWidgetId = window.turnstile.render(widget);
      widget.dataset.turnstileRendered = 'true';
      return;
    }
    if (attempt < 20) {
      window.setTimeout(() => this.renderTurnstile(attempt + 1), 250);
    }
  }

  async submitQuote() {
    const submitButton = this.form.querySelector('.quote-cart-form__submit');

    this.renderTurnstile();
    const formData = new FormData(this.form);
    const turnstileToken = formData.get('cf-turnstile-response');
    if (!turnstileToken) {
      this.status.textContent = 'Please complete the verification below and try again.';
      return;
    }

    submitButton.disabled = true;
    this.status.textContent = 'Sending your quote request…';

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const lineItems = cart.items.map((item) => ({
        variantId: item.variant_id,
        quantity: item.quantity,
        title: item.title,
      }));

      const payload = {
        name: formData.get('name'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        company: formData.get('company'),
        requiredBy: formData.get('requiredBy'),
        note: formData.get('note'),
        website: formData.get('website'),
        turnstileToken,
        lineItems,
      };

      const response = await fetch(this.workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (result.ok) {
        this.status.textContent = `Thanks! Your quote request (${result.name}) has been received — we'll be in touch shortly.`;
        if (document.documentElement.dataset.b2b !== '1') {
          this.status.insertAdjacentHTML('beforeend', ' <a href="/pages/trade-account">Business buyer? Apply for a trade account</a>');
        }
        this.form.reset();
        if (this.turnstileWidgetId && window.turnstile && typeof window.turnstile.reset === 'function') {
          window.turnstile.reset(this.turnstileWidgetId);
        }
        submitButton.disabled = false;
      } else {
        this.status.textContent = `Sorry, that didn't go through: ${(result.errors || []).join(', ')}`;
        submitButton.disabled = false;
      }
    } catch (error) {
      this.status.textContent = 'Sorry, something went wrong sending your request. Please try again.';
      submitButton.disabled = false;
    }
  }
}

if (!customElements.get('quote-cart-form')) {
  customElements.define('quote-cart-form', QuoteCartForm);
}
